import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export default function Register() {
    const { registerCustomer } = useAuth();
    const navigate = useNavigate();
    const [malls, setMalls] = useState([]);
    const [form, setForm] = useState({
        name: '', email: '', password: '', mobile: '', city: '', preferred_mall_id: '',
    });
    const [busy, setBusy] = useState(false);

    useEffect(() => { api.get('/malls').then(({ data }) => setMalls(data)); }, []);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await registerCustomer(form);
            toast.success('Welcome to Inorbit One! 500 welcome points credited.');
            navigate('/loyalty');
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Could not create account');
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2" data-testid="register-page">
            <div className="hidden md:block relative">
                <img src="https://static.wixstatic.com/media/9bdc47_eb8e086c78e847e6b548181a8b5cb027~mv2.png" alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
                <div className="absolute bottom-16 left-16 right-16 text-white">
                    <div className="overline text-gold mb-6">Become a Member</div>
                    <div className="font-serif text-5xl leading-tight">Begin your<br /><span className="italic text-gold">Inorbit One</span> journey.</div>
                    <ul className="mt-8 space-y-2 text-white/80 text-sm">
                        <li>• 500 welcome points instantly</li>
                        <li>• Cross-mall loyalty & rewards</li>
                        <li>• Personalised offers from 500+ brands</li>
                        <li>• AI Concierge at your service</li>
                    </ul>
                </div>
            </div>
            <div className="flex items-center justify-center px-6 md:px-16 py-16 bg-ivory">
                <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
                    <Link to="/" className="overline text-gold">INORBIT ONE</Link>
                    <h1 className="font-serif text-5xl text-navy mt-6 mb-12 leading-tight">Create<br /><span className="italic text-gold">your account.</span></h1>
                    <div className="space-y-6">
                        <div>
                            <label className="overline">Full Name</label>
                            <input className="input-luxury" value={form.name} onChange={set('name')} required data-testid="register-name" />
                        </div>
                        <div>
                            <label className="overline">Email</label>
                            <input className="input-luxury" type="email" value={form.email} onChange={set('email')} required data-testid="register-email" />
                        </div>
                        <div>
                            <label className="overline">Password</label>
                            <input className="input-luxury" type="password" value={form.password} onChange={set('password')} required minLength={6} data-testid="register-password" />
                        </div>
                        <div>
                            <label className="overline">Mobile (optional)</label>
                            <input className="input-luxury" value={form.mobile} onChange={set('mobile')} data-testid="register-mobile" />
                        </div>
                        <div>
                            <label className="overline">City</label>
                            <input className="input-luxury" value={form.city} onChange={set('city')} data-testid="register-city" />
                        </div>
                        <div>
                            <label className="overline">Preferred Mall</label>
                            <select className="input-luxury" value={form.preferred_mall_id} onChange={set('preferred_mall_id')} data-testid="register-mall">
                                <option value="">Select a mall</option>
                                {malls.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
                            </select>
                        </div>
                    </div>
                    <button type="submit" disabled={busy} className="btn-gold mt-12 w-full justify-center" data-testid="register-submit-btn">
                        {busy ? 'Creating account…' : 'Create Account'}
                    </button>
                    <div className="mt-8 text-sm text-text-secondary text-center">
                        Already a member?{' '}
                        <Link to="/login" className="text-navy font-medium underline" data-testid="register-to-login">Sign in</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
